import { render } from "./LoginByTokenView.vue?vue&type=template&id=2ff04a96&ts=true"
import script from "./LoginByTokenView.vue?vue&type=script&lang=ts"
export * from "./LoginByTokenView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__